export default __webpack_public_path__ + "static/media/Medical-equipment-bg.ff959f8f.svg";